import * as v from "valibot";

import { rpcContract } from "../rpc";

export const authResultSchema = v.required(
  v.object({
    accessToken: v.string(),
  }),
);

export type AuthRole = "superuser" | "admin" | "user";
export type AccountStatus = "CONFIRMED" | "UNCONFIRMED";
export type AuthUserBase = {
  name: string;
  email?: string;
  roles: AuthRole[];
  avatarUrl?: string;
  handle?: string;
  memberSinceDate?: string;
  preferences?: { themes?: string[]; chatDisplayName?: string };
  creatorsFollowing?: string[];
  accountStatus?: AccountStatus;
  emailVerified?: boolean;
};
export interface AuthToken extends AuthUserBase {
  sub: string;
  exp: number;
}

export interface AuthUser extends AuthUserBase {
  id: string;
}

export type AuthResult = v.InferOutput<typeof authResultSchema>;

export const authRpcContract = rpcContract({
  paramsSchema: v.object({
    username: v.pipe(v.string(), v.minLength(3)),
    password: v.pipe(v.string(), v.minLength(4)),
  }),
  resultSchema: authResultSchema,
  name: "auth",
});

export type AuthParams = v.InferOutput<(typeof authRpcContract)["paramsSchema"]>;
